import {clientConfig} from "../../main-app/config/client-config";
import {ArticlesHeadersHandler} from "../../main-app/handlers/input/headers/articles-headers-handler";
import {errorHandler} from "../../main-app/handlers/error-handler/error-handler";

export default class QuerySchedulingAppDataHandler {

    constructor(preloaderHandler, querySchedulingAppInputsHandler, toastHandler) {
        this.preloaderHandler = preloaderHandler;
        this.saveButton = $("#saveButton");
        this.cancelButton = $(".cancel-scheduling");
        this.querySchedulingAppInputsHandler = querySchedulingAppInputsHandler;
        this.createSchedulingForm = $("#createQuerySchedulingForm")[0];
        this.articlesHeadersHandler = new ArticlesHeadersHandler();
        this.toastHandler = toastHandler;
        this.buttons = $(".query-scheduling-action");
        this.customAction = null;
    }

    init() {
        const self = this;
        self.buttons.on("click", function (){
            self.customAction = $(this).attr("customAction");
        });
        self.createSchedulingForm.addEventListener('submit', async function (event) {
            event.preventDefault();
            const inputs = document.querySelectorAll('form .need-validation');
            const inputWrappers = document.querySelectorAll('form .query-scheduling-app-input-wrapper');
            inputs.forEach(input => {
                input.classList.remove('is-invalid');
                input.classList.remove('is-valid');
            });
            inputWrappers.forEach(inputWrapper => {
                inputWrapper.classList.add('was-validated');
            });
            if (!self.createSchedulingForm.checkValidity()) {
                return;
            }
            self.preloaderHandler.show();
            try {
                const invalidInputs = await self.customValidation();
                if (invalidInputs.length) {
                    invalidInputs.forEach(invalidInput => {
                        invalidInput.input.parentElement.querySelector(".invalid-feedback").innerText = invalidInput.message;
                        invalidInput.input.classList.add('is-invalid')
                    });
                    self.preloaderHandler.hide();
                    return;
                }
                if (self.customAction === "sample"){
                    await self.createSample();
                }
                else{
                    await self.createScheduling();
                }
            } catch (e) {
                self.handleError(e);
            }
            self.preloaderHandler.hide();
        }, false);

        self.cancelButton.on("click", async function (e) {
            e.preventDefault();
            self.preloaderHandler.show();
            const inputs = document.querySelectorAll('form .cancel-validation');
            const inputWrappers = document.querySelectorAll('form .cancel-validation-wrapper');
            inputWrappers.forEach(inputWrapper => {
                inputWrapper.classList.add('was-validated');
            });
            inputs.forEach(input => {
                input.classList.remove('is-invalid');
                input.classList.remove('is-valid');
                if (!input.checkValidity()) {
                    self.preloaderHandler.hide();
                    return;
                }
            });
            try {
                const cancelResponse = await self.cancelScheduling();
                if (!cancelResponse.deletedCount){
                    self.toastHandler.showErrorToast("Error: query does not exist");
                }
                else {
                    self.toastHandler.showToast("Scheduling deleted successfully");
                }
            } catch (e) {
                self.handleError(e);
            }
            self.preloaderHandler.hide();
        })
    }

    async customValidation() {
        const self = this;
        const output = [];
        let queryInput = self.querySchedulingAppInputsHandler.query[0];
        const queryValidationResult = await self.validateQuery(queryInput.value);
        if (queryValidationResult.error) {
            output.push({
                input: queryInput,
                message: queryValidationResult.message.message
            });
        }
        return output;
    }

    async validateQuery(query) {
        const self = this;
        if (query.indexOf("type:Article ") < 0 && query !== "type:Article") {
            return {
                error: true,
                message: "Only Article queries are supported at this time"
            };
        }
        const queryValidationResponse = await self.executeQueryValidation(query);
        if (queryValidationResponse.error) {
            return {
                error: true,
                message: queryValidationResponse.message
            };
        }
        return {
            error: false
        };
    }

    executeQueryValidation(query) {
        return $.ajax({
            url: clientConfig.appEndpoint + "app/metadata/get-number-of-entities-by-query?query=" + encodeURIComponent(query),
            type: 'GET',
            dataType: 'json',
            cache: false,
        });
    }

    async createScheduling() {
        const self = this;
        let queryId = self.querySchedulingAppInputsHandler.queryId;
        const queryName = self.querySchedulingAppInputsHandler.queryName.val();
        try {
            if (!queryId) {
                const saveQueryResponse = await self.saveQuery(queryId, queryName);
                queryId = saveQueryResponse.createdSavedSearch.id;
            }
            await self.executeCreate(queryId);
            self.toastHandler.showToast("Scheduling saved successfully");
        } catch (e) {
            self.handleError(e);
        }
    }

    executeCreate(queryId) {
        const self = this;
        const headersOutput = self.articlesHeadersHandler.getHeaders();
        const data = {
            token: self.querySchedulingAppInputsHandler.token.val(),
            query: {
                name: self.querySchedulingAppInputsHandler.queryName.val(),
                value: self.querySchedulingAppInputsHandler.query.val(),
                id: parseInt(queryId)
            },
            intervalHours: parseInt(self.querySchedulingAppInputsHandler.intervalHours),
            email: self.querySchedulingAppInputsHandler.email.val(),
            headers: headersOutput,
            articleConfig: self.querySchedulingAppInputsHandler.getArticleConfig()
        };
        console.log(data);
        return $.ajax({
            url: clientConfig.appEndpoint + "app/saved-searched-scheduling/create",
            type: 'POST',
            dataType: 'json',
            'headers': {
                'Content-Type': 'application/json'
            },
            data: JSON.stringify(data),
            cache: false
        });
    }

    executeSample(queryId) {
        const self = this;
        const headersOutput = self.articlesHeadersHandler.getHeaders();
        const data = {
            token: self.querySchedulingAppInputsHandler.token.val(),
            query: {
                name: self.querySchedulingAppInputsHandler.queryName.val(),
                value: self.querySchedulingAppInputsHandler.query.val(),
                id: parseInt(queryId)
            },
            email: self.querySchedulingAppInputsHandler.email.val(),
            headers: headersOutput,
            articleConfig: self.querySchedulingAppInputsHandler.getArticleConfig()
        };
        return $.ajax({
            url: clientConfig.appEndpoint + "app/saved-searched-scheduling/create-sample",
            type: 'POST',
            dataType: 'json',
            'headers': {
                'Content-Type': 'application/json'
            },
            data: JSON.stringify(data),
            cache: false
        });
    }

    async createSample() {
        const self = this;
        let queryId = self.querySchedulingAppInputsHandler.queryId;
        const queryName = self.querySchedulingAppInputsHandler.queryName.val();
        try {
            if (!queryId) {
                const saveQueryResponse = await self.saveQuery(queryId, queryName);
                queryId = saveQueryResponse.createdSavedSearch.id;
            }
            await self.executeSample(queryId);
            self.toastHandler.showToast("Sample sent successfully");
        } catch (e) {
            self.handleError(e);
        }
    }

    saveQuery() {
        const self = this;
        const requestBody = {
            token: self.querySchedulingAppInputsHandler.token.val(),
            query: self.querySchedulingAppInputsHandler.query.val(),
            name: self.querySchedulingAppInputsHandler.queryName.val()
        }
        return $.ajax({
            url: clientConfig.usersBotApi + "/saved-searches/create-by-token",
            type: 'POST',
            dataType: 'json',
            data: JSON.stringify(requestBody),
            'headers': {
                'Content-Type': 'application/json'
            },
            cache: false
        });
    }


    cancelScheduling() {
        const self = this;
        const data = {
            token: self.querySchedulingAppInputsHandler.token.val(),
            queryId: self.querySchedulingAppInputsHandler.queryId,
            queryName: self.querySchedulingAppInputsHandler.queryName.val()
        };
        return $.ajax({
            url: clientConfig.appEndpoint + "app/saved-searched-scheduling/delete",
            type: 'POST',
            dataType: 'json',
            'headers': {
                'Content-Type': 'application/json'
            },
            data: JSON.stringify(data),
            cache: false
        });
    }

    handleError(e) {
        console.error(e);
        let message = "There was an error processing the request.";
        if (e.status >= 400 && e.status < 500) {
            message = message + " Error: " + e.responseText;
        }
        errorHandler.showModal(message, false);
    }

}